import get from "lodash/get";
import { RouterRule } from "../types";

import { getWidgetData } from "../reducers/methods";

function testRule(
  rule: RouterRule,
  data: ReturnType<typeof getWidgetData>
): boolean {
  switch (rule.operator) {
    case "is":
      return get(data, rule.attribute) === rule.value;
    case "isDefined":
      return get(data, rule.attribute);
    case "isNotDefined":
      return !get(data, rule.attribute);
    default:
      return false;
  }
}

export function getScreen(
  rules: RouterRule[],
  data: ReturnType<typeof getWidgetData>
): string | undefined {
  for (const rule of rules) {
    if (testRule(rule, data)) {
      return rule.screen;
    }
  }

  return undefined;
}
